import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Styles from './ProjectEditButton.styles';

const ProjectEditButton = (props) => {
  // @TODO edit form
  if (props.selected.length === 1) {
    return (
      <div>
        <div
          role="button"
          tabIndex={-1}
          style={[Styles.button.base, Styles.button.yellow]}
          onClick={props.onClick}
        >
          Edit item
        </div>
      </div>
    );
  }
  return null;
};

ProjectEditButton.propTypes = {
  selected: PropTypes.arrayOf(Object).isRequired,
  onClick: PropTypes.func.isRequired,
};

ProjectEditButton.defaultProps = {};

export default Radium(ProjectEditButton);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectEditButton/ProjectEditButton.js